import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import {MFA_SMS, MFA_EMAIL} from "../constants";

const options = {
    postUrl: `${process.env.MIX_API_URL}v1/create-mfa`,
    success: "Code sent!"
}

const state = {
    action: ''
}

const MfaForm = (props) => {

    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <div>
                <p>Please provide the one-time verification code sent to you.</p>
                <p>This is a process called Multi-Factor Authentication (MFA), which has been introduced to strengthen the security of your account.</p>
            </div>

            {props.mobileNumber && <label className='d-block mt-4'>
                <input type="radio" value={MFA_SMS} name="action" onChange={() => props.setDynamicValues({action: MFA_SMS})} checked={props.values.action === MFA_SMS} />
                &nbsp;Send an SMS to - { props.mobileNumber }
            </label>}

            {props.emailAddress && <label className='d-block mt-4'>
                <input type="radio" value={MFA_EMAIL} name="action" onChange={() => props.setDynamicValues({action: MFA_EMAIL})} checked={props.values.action === MFA_EMAIL} />
                &nbsp;Send an email to - { props.emailAddress }
            </label>}

            {props.children}

            <div className='mt-4'>
                <Button title='Send Code' action={props.handleSubmit} />
            </div>
        </form>
    )
}

export default FormHOC(MfaForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/MfaForm.js